module.exports = __webpack_public_path__ + "static/media/arch-13.bb90558f.jpg";